export const GET_ALLERGIC_HISTORY_DATA = "get_allergic_history_data";
export const REQ_ALLERGIC_HISTORY_DATA = "req_allergic_history_data";
export const SET_ALLERGIC_HISTORY_DATA = "set_allergic_history_data";
export const GET_ALLERGIC_LIST = "get_allergic_list";
